exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".border-component{border-radius:2px;border:1px solid #ddd;padding:4px}.border-component.no-padding{padding:0}", ""]);

// exports
